var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "25px",
    viewBox: "0 0 30 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      background: "#FFFFFF"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_table") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_table",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 30,
    height: 25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 2.30075188,
    x2: 10.5,
    y2: 24.5,
    id: "Line-2",
    stroke: "#979797",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.7368421,
    y1: 3.15789474,
    x2: 19.7368421,
    y2: 24.4736842,
    id: "Line-2",
    stroke: "#979797",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.2105263,
    y1: 12.5789474,
    x2: 0.789473684,
    y2: 12.5789474,
    id: "Line-2",
    stroke: "#979797",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.2105263,
    y1: 18.8947368,
    x2: 0.789473684,
    y2: 18.8947368,
    id: "Line-2",
    stroke: "#979797",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1F6383",
    fill: "#1F6383",
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#3D3F42",
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 24
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTable);
export default __webpack_public_path__ + "static/media/icon_table.cbda867379d0c68d5c4ff410898bfe77.svg";
export { ForwardRef as ReactComponent };